module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dugIW"))).then(() => module.bundle.root('1iHdE'));